"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-3f83bcf2"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-4 flex flex-col border border-gray rounded"
};
const _hoisted_2 = { class: "flex items-end print:hidden mb-4" };
const _hoisted_3 = { class: "xl:flex flex-col no-wrap xl:flex-row justify-between border-b-2 border-gray uppercase font-bold hidden print:flex" };
const _hoisted_4 = { class: "w-full py-1 px-2" };
const _hoisted_5 = { class: "w-full py-1 px-2" };
const _hoisted_6 = {
    key: 0,
    class: "w-full py-1 px-2"
};
const _hoisted_7 = { class: "w-full py-1 px-2" };
const _hoisted_8 = { class: "w-full py-1 px-2" };
const _hoisted_9 = { class: "w-full py-1 px-2" };
const _hoisted_10 = { class: "w-full py-1 px-2" };
const _hoisted_11 = { class: "w-full text-center py-1 px-2 print:hidden" };
const _hoisted_12 = { class: "w-full py-1 px-2 xl:text-right" };
const _hoisted_13 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_14 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_17 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
    key: 0,
    class: "flex flex-row gap-4 w-full py-1 px-2"
};
const _hoisted_20 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_21 = { class: "self-center w-full text-right md:text-left" };
const _hoisted_22 = { key: 0 };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-fuel_label" }, null, -1));
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1));
const _hoisted_25 = { key: 1 };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-rain_label" }, null, -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1));
const _hoisted_28 = { key: 2 };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-noise_label" }, null, -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1));
const _hoisted_31 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_32 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_33 = { class: "self-center w-full text-right md:text-left" };
const _hoisted_34 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_35 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_36 = { class: "self-center w-full text-right md:text-left" };
const _hoisted_37 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_38 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_39 = { class: "self-center w-full text-right md:text-left" };
const _hoisted_40 = { class: "flex flex-row gap-4 w-full py-1 px-2 print:hidden" };
const _hoisted_41 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_42 = { class: "flex items-center w-full justify-end md:justify-start gap-0.5" };
const _hoisted_43 = {
    key: 0,
    class: "marso-icon-info-circle tooltip text-blue"
};
const _hoisted_44 = {
    key: 0,
    class: "!flex !flex-col !gap-2 tooltip-content !p-3"
};
const _hoisted_45 = { class: "text-center text-lg" };
const _hoisted_46 = { class: "flex-row gap-4 w-full py-1 px-2 hidden print:flex" };
const _hoisted_47 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden" };
const _hoisted_48 = { class: "w-full hidden text-right md:text-left print:flex self-center" };
const _hoisted_49 = { class: "flex flex-row gap-4 w-full py-1 px-2 print:hidden" };
const _hoisted_50 = { class: "self-center w-full uppercase font-bold xl:hidden" };
const _hoisted_51 = { class: "flex w-full justify-end md:justify-start" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-blue text-white font-bold flex items-center self-center p-[10px] rounded-r-lg h-12 border-1 border-blue" }, " % ", -1));
const _hoisted_53 = { class: "flex flex-row gap-4 w-full py-1 px-2" };
const _hoisted_54 = { class: "self-center w-full uppercase font-bold xl:hidden print:hidden xl:text-right" };
const _hoisted_55 = { class: "self-center w-full text-right md:text-left xl:text-right" };
const _hoisted_56 = { class: "mb-3 border-t-2 border-b-2 border-[#929292]" };
const _hoisted_57 = { class: "flex py-[6px]" };
const _hoisted_58 = { class: "grow font-bold" };
const _hoisted_59 = { class: "flex-[0_0_150px] text-right font-bold text-[18px] print:text-[14px]" };
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const i18n_1 = require("../../common/i18n");
const pricingStore_1 = require("../../stores/pricing/pricingStore");
const vue_router_1 = require("vue-router");
const securityStore_1 = require("../../stores/security/securityStore");
const PricingEnum_1 = require("../../stores/pricing/PricingEnum");
const toastStore_1 = require("../../stores/toast/toastStore");
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartSummary',
    props: {
        isCustomPriceViewActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ["updateTotalGrossValue"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const prices = (0, vue_3.ref)({});
        const router = (0, vue_router_1.useRouter)();
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const pricingStore = (0, pricingStore_1.usePricingStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const pricingInfo = (0, vue_3.ref)({});
        const isCustomPriceViewActive = (0, vue_3.computed)(() => customDesignStore.isCustomPriceViewActive);
        (0, vue_3.onMounted)(() => {
            if (!currentUser.value)
                return;
            // initializeStore meghívása a jogososultság(ok) ellenőrzésére.
            customDesignStore.initializeStore(currentUser.value);
            // Csak akkor kérjük le az árazás információkat, ha a "isCustomPriceViewActive" aktív.
            if (customDesignStore.isCustomPriceViewActive) {
                getPricingInfo();
            }
        });
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const activeCartProducts = (0, vue_3.computed)(() => {
            var _a;
            return (_a = activeCart.value) === null || _a === void 0 ? void 0 : _a.products;
        });
        const calculateGrossValue = (product) => {
            return product.quantity * product.grossUnitPriceWithProfit;
        };
        const formattedTotalGrossValue = (0, vue_3.computed)(() => {
            let totalGrossValue = 0;
            let currencyCode = "";
            quoteProducts.value.map((product) => {
                totalGrossValue += calculateGrossValue(product);
                currencyCode = product.currencyCode;
            });
            quoteProducts.value.forEach((product) => {
                prices.value[product.id] = {
                    netUnitPriceWithProfit: (0, shop_1.formatPrice)(product.netUnitPriceWithProfit, product.currencyCode),
                    vatValueWithProfit: (0, shop_1.formatPrice)(product.vatValueWithProfit, product.currencyCode),
                    grossUnitPrice: (0, shop_1.formatPrice)(product.grossUnitPriceWithProfit, product.currencyCode),
                    totalGross: (0, shop_1.formatPrice)(calculateGrossValue(product), product.currencyCode)
                };
            });
            prices.value['totalPrice'] = {
                totalPrice: (0, shop_1.formatPrice)(totalGrossValue, currencyCode)
            };
            emit("updateTotalGrossValue");
            return (0, shop_1.formatPrice)(totalGrossValue, currencyCode);
        });
        const quoteProducts = (0, vue_3.ref)([]);
        const commonProfitPercentage = (0, vue_3.ref)(0);
        const profitPercentageChanged = (profitPercentage, product) => {
            // valtozik az egy termekre vonatkozo % merteke
            quoteProducts.value.map((quoteProduct) => {
                if (quoteProduct.id === product.id) {
                    product.grossUnitPriceWithProfit = (0, shop_1.roundByCurrency)(((100 + profitPercentage) / 100) * product.grossUnitPrice, quoteProduct.currencyCode);
                    product.netUnitPriceWithProfit = (0, shop_1.roundByCurrency)(((100 + profitPercentage) / 100) * product.netUnitPrice, quoteProduct.currencyCode);
                    product.vatValueWithProfit = (0, shop_1.roundByCurrency)(((100 + profitPercentage) / 100) * product.vatValue, quoteProduct.currencyCode);
                    product.profitPercentage = profitPercentage;
                }
                return product;
            });
        };
        const grossUnitPriceWithProfitChanged = (grossUnitPriceWithProfit, product) => {
            // valtozik az osszeg, egy adott termeknel
            quoteProducts.value.map((quoteProduct) => {
                if (quoteProduct.id === product.id) {
                    // itt kell kerekiteni a megengedett szamra
                    product.grossUnitPriceWithProfit = (0, shop_1.roundByCurrency)(grossUnitPriceWithProfit, quoteProduct.currencyCode);
                    let profitPercentage = (grossUnitPriceWithProfit / product.grossUnitPrice - 1) * 100;
                    product.profitPercentage = Math.round(100 * profitPercentage) / 100;
                    product.netUnitPriceWithProfit = (0, shop_1.roundByCurrency)(((100 + profitPercentage) / 100) * product.netUnitPrice, quoteProduct.currencyCode);
                    product.vatValueWithProfit = (0, shop_1.roundByCurrency)(((100 + profitPercentage) / 100) * product.vatValue, quoteProduct.currencyCode);
                }
                return product;
            });
        };
        const applyCommonProfitPercentageOnAllRows = () => {
            // valtozik a minden termekre vonatkozo % merteke
            quoteProducts.value.map((quoteProduct) => {
                quoteProduct.grossUnitPriceWithProfit = (0, shop_1.roundByCurrency)(((100 + commonProfitPercentage.value) / 100) * quoteProduct.grossUnitPrice, quoteProduct.currencyCode);
                quoteProduct.netUnitPriceWithProfit = (0, shop_1.roundByCurrency)(((100 + commonProfitPercentage.value) / 100) * quoteProduct.netUnitPrice, quoteProduct.currencyCode);
                quoteProduct.vatValueWithProfit = (0, shop_1.roundByCurrency)(((100 + commonProfitPercentage.value) / 100) * quoteProduct.vatValue, quoteProduct.currencyCode);
                quoteProduct.profitPercentage = commonProfitPercentage.value;
                return quoteProduct;
            });
        };
        const hasTyreLabeling = () => {
            return quoteProducts.value.some(product => {
                return product.fuelEfficiency || product.noiseMeasurementValue || product.wetGripClass;
            });
        };
        const calculateNetPrice = (priceNet, priceCustomNet) => customDesignStore.isCustomPriceViewActive ? priceCustomNet : priceNet;
        const calculateVatValue = (priceNet, priceCustomNet, vatPercent) => {
            if (customDesignStore.isCustomPriceViewActive) {
                return (priceCustomNet * ((100 + vatPercent) / 100)) - priceCustomNet;
            }
            else {
                return (priceNet * ((100 + vatPercent) / 100)) - priceNet;
            }
        };
        const calculateGrossPrice = (priceNet, priceCustomNet, vatPercent) => {
            if (customDesignStore.isCustomPriceViewActive) {
                return priceCustomNet * ((100 + vatPercent) / 100);
            }
            else {
                return priceNet * ((100 + vatPercent) / 100);
            }
        };
        const getPricingInfo = async () => {
            var _a, _b, _c, _d;
            try {
                if (!((_b = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.id))
                    return;
                await pricingStore.getPricings(router, { "customer.id": currentUser.value.customer.id, status: PricingEnum_1.PricingStatusEnum.ACTIVE });
                if (!((_c = activeCartProducts.value) === null || _c === void 0 ? void 0 : _c.length) || !((_d = pricingStore.pricings) === null || _d === void 0 ? void 0 : _d.length))
                    return;
                activeCartProducts.value.forEach(product => {
                    var _a;
                    const matchingPricing = pricingStore.pricings.find(pricing => pricing.id === product.priceCustomNetId);
                    if (!matchingPricing)
                        return;
                    const matchingFilter = (_a = matchingPricing.customerPricingFilters) === null || _a === void 0 ? void 0 : _a.find(filter => filter.brand === product.brandName && filter.diameter === product.diameter);
                    if (matchingFilter) {
                        const text = matchingFilter.fixedPricing
                            ? `${matchingFilter.brand} + ${matchingFilter.diameter}" -> +${(0, shop_1.formatPrice)(matchingFilter.fixedPricing, product.currencyCode)}`
                            : `${matchingFilter.brand} + ${matchingFilter.diameter}" -> +${matchingFilter.percentPricing}%`;
                        pricingInfo.value[matchingPricing.id] = {
                            name: matchingPricing.name,
                            text: text
                        };
                    }
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.watchEffect)(() => {
            var _a;
            if (activeCartProducts.value !== undefined) {
                quoteProducts.value = [];
                (_a = activeCartProducts.value) === null || _a === void 0 ? void 0 : _a.forEach((value) => {
                    quoteProducts.value.push({
                        id: value.id,
                        name: value.getProductName(),
                        // TODO lehet, hogy hozza kell adni az eco price-ot is?
                        netUnitPrice: (0, shop_1.roundByCurrency)(calculateNetPrice(value.priceNet, value.priceCustomNet), value.currencyCode),
                        vatValue: calculateVatValue(value.priceNet, value.priceCustomNet, value.priceVatPercent),
                        grossUnitPrice: (0, shop_1.roundByCurrency)(calculateGrossPrice(value.priceNet + value.priceEco, value.priceCustomNet + value.priceEco, value.priceVatPercent), value.currencyCode),
                        quantity: value.quantity,
                        currencyCode: value.currencyCode,
                        profitPercentage: 0,
                        netUnitPriceWithProfit: (0, shop_1.roundByCurrency)(calculateNetPrice(value.priceNet, value.priceCustomNet), value.currencyCode),
                        vatValueWithProfit: (0, shop_1.roundByCurrency)(calculateVatValue(value.priceNet, value.priceCustomNet, value.priceVatPercent), value.currencyCode),
                        grossUnitPriceWithProfit: (0, shop_1.roundByCurrency)(calculateGrossPrice(value.priceNet + value.priceEco, value.priceCustomNet + value.priceEco, value.priceVatPercent), value.currencyCode),
                        size: value.getDetailsSize(),
                        priceVatPercent: value.priceVatPercent,
                        fuelEfficiency: value.fuelEfficiency,
                        wetGripClass: value.wetGripClass,
                        noiseMeasurementValue: value.noiseMeasurementValue,
                        priceCustomNetId: value.priceCustomNetId
                    });
                });
            }
        });
        (0, vue_3.onUnmounted)(() => {
            pricingStore.resetState();
        });
        expose({
            prices,
            isCustomPriceViewActive
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(activeCart) !== undefined && (0, vue_2.unref)(activeCart).getSize())
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            id: "cart-summary-common-profit-percentage-input",
                            modelValue: commonProfitPercentage.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((commonProfitPercentage).value = $event)),
                            type: "number",
                            label: (0, vue_2.unref)(i18n_1.trans)('common_profit_percentage', 'Common profit percentage: ', 'quote'),
                            class: "max-w-[150px] mr-3",
                            border: ""
                        }, null, 8, ["modelValue", "label"]),
                        (0, vue_2.createElementVNode)("button", {
                            id: "cart-summary-apply-on-all-rows-button",
                            class: "btn btn-rounded btn-primary",
                            onClick: applyCommonProfitPercentageOnAllRows
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("common_profit_percentage_button", "Apply on all rows", "quote")), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_size", "Size", "quote")), 1),
                        (hasTyreLabeling())
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_label", "Tyre labeling", "quote")), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_unit_price", "Net unit price", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_vat_value", "VAT value", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_unit_price", "Gross unit price", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_profit_percentage", "Profit percentage", "quote")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "quote")), 1)
                    ]),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(quoteProducts.value, (product, i) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: product.id,
                            class: "flex flex-col no-wrap gap-2 xl:flex-row justify-between border-gray border-b-1"
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", {
                                    class: "self-center w-full text-right md:text-left",
                                    innerHTML: product.name
                                }, null, 8, _hoisted_15)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_size", "Size", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", {
                                    class: "self-center w-full text-right md:text-left",
                                    innerHTML: product.size
                                }, null, 8, _hoisted_18)
                            ]),
                            (hasTyreLabeling())
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_label", "Tyre labeling", "quote")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                        (product.fuelEfficiency &&
                                            product.fuelEfficiency != '')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_22, [
                                                _hoisted_23,
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(product.fuelEfficiency), 1)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        _hoisted_24,
                                        (product.wetGripClass && product.wetGripClass != '')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, [
                                                _hoisted_26,
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(product.wetGripClass), 1)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        _hoisted_27,
                                        (product.noiseMeasurementValue &&
                                            product.noiseMeasurementValue != 0)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_28, [
                                                _hoisted_29,
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(product.noiseMeasurementValue) + "dB ", 1)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        _hoisted_30
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_33, (0, vue_2.toDisplayString)(product.quantity), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                (0, vue_2.createElementVNode)("div", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_unit_price", "Net unit price", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_36, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(product.netUnitPriceWithProfit, product.currencyCode)), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                (0, vue_2.createElementVNode)("div", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_vat_value", "VAT value", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_39, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(product.vatValueWithProfit, product.currencyCode)), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                (0, vue_2.createElementVNode)("div", _hoisted_41, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_unit_price", "Gross unit price", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                    (product.priceCustomNetId && (0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_43, [
                                            (pricingInfo.value[product.priceCustomNetId])
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_44, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("pricing_information", "Pricing information", "quote")), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("id", "ID", "quote")) + ": " + (0, vue_2.toDisplayString)(product.priceCustomNetId), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("name", "Name", "quote")) + ": " + (0, vue_2.toDisplayString)(pricingInfo.value[product.priceCustomNetId].name), 1),
                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(pricingInfo.value[product.priceCustomNetId].text), 1)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createTextVNode)("️ "),
                                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                        modelValue: product.grossUnitPriceWithProfit,
                                        "onUpdate:modelValue": ($event) => ((product.grossUnitPriceWithProfit) = $event),
                                        type: "number",
                                        border: "",
                                        class: "max-w-[136px]",
                                        onChange: ($event) => (grossUnitPriceWithProfitChanged($event.target.value, product))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                (0, vue_2.createElementVNode)("div", _hoisted_47, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_unit_price_with_profit", "Gross unit price with profit", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_48, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(product.grossUnitPriceWithProfit, product.currencyCode)), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                (0, vue_2.createElementVNode)("div", _hoisted_50, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_profit_percentage", "Profit percentage", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                        id: `cart-summary-profit-percentage-${i}`,
                                        modelValue: product.profitPercentage,
                                        "onUpdate:modelValue": ($event) => ((product.profitPercentage) = $event),
                                        type: "number",
                                        border: "",
                                        class: "max-w-[100px]",
                                        onChange: ($event) => (profitPercentageChanged(Number($event.target.value), product))
                                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange"]),
                                    _hoisted_52
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                (0, vue_2.createElementVNode)("div", _hoisted_54, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "quote")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_55, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(calculateGrossValue(product), product.currencyCode)), 1)
                            ])
                        ]));
                    }), 128)),
                    (0, vue_2.createElementVNode)("div", _hoisted_56, [
                        (0, vue_2.createElementVNode)("div", _hoisted_57, [
                            (0, vue_2.createElementVNode)("div", _hoisted_58, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_total", "Gross total", "quote")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_59, (0, vue_2.toDisplayString)((0, vue_2.unref)(formattedTotalGrossValue)), 1)
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
